import { render, staticRenderFns } from "./CancelSubmitForm18.vue?vue&type=template&id=454802b9&scoped=true"
import script from "./CancelSubmitForm18.vue?vue&type=script&lang=ts"
export * from "./CancelSubmitForm18.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454802b9",
  null
  
)

export default component.exports